import _ from 'lodash'

export default {
  setEmployerPriceCategories(state, value) {
    state.employerPriceCategories = value
  },
  addEmployerPriceCategories(state, employerPriceCategory) {
    state.employerPriceCategories.unshift(employerPriceCategory)
  },
  updateEmployerPriceCategoriesField(state, payload) {
    const employerPriceCategory = _.find(state.employerPriceCategories, employerPriceCategory => {
      return employerPriceCategory.id == payload.id
    })

    employerPriceCategory[payload.key] = payload.value
  },
  removeEmployerPriceCategory(state, index) {
    state.employerPriceCategories.splice(index, 1)
  },
}
